import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export const sessionRestoreModalSegment = stateSegmentWithReset<{
  isVisible: boolean;
}>({
  isVisible: false,
});

sessionRestoreModalSegment.debugLabel = 'sessionRestoreModalSegment';
